import * as React from 'react';
import * as S from './type-filter-bar.styles';

export interface ITypeFilterBarProps {
    className?: string;
    children?: React.ReactNode;
}

/**
 * Segmented type/tab filter bar (Messaging TypeFilterBar pattern).
 */
export const TypeFilterBar: React.FC<ITypeFilterBarProps> = ({ className, children }) => (
    <S.Bar className={className}>{children}</S.Bar>
);

export interface ITypeFilterChipProps {
    active?: boolean;
    disabled?: boolean;
    className?: string;
    type?: 'button' | 'submit' | 'reset';
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    children?: React.ReactNode;
}

export const TypeFilterChip: React.FC<ITypeFilterChipProps> = ({
    active,
    disabled,
    className,
    type = 'button',
    onClick,
    children,
}) => (
    <S.Chip
        active={active}
        disabled={disabled}
        className={className}
        type={type}
        onClick={onClick}>
        {children}
    </S.Chip>
);

export interface ITypeCountBadgeProps {
    active?: boolean;
    className?: string;
    children?: React.ReactNode;
}

export const TypeCountBadge: React.FC<ITypeCountBadgeProps> = ({ active, className, children }) => (
    <S.Count active={active} className={className}>
        {children}
    </S.Count>
);
